
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[slug]",
      function () {
        return require("private-next-pages/shops/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[slug]"])
      });
    }
  